import { render, staticRenderFns } from "./VoluntaryCessions.vue?vue&type=template&id=abb97eb8&"
import script from "./VoluntaryCessions.vue?vue&type=script&lang=js&"
export * from "./VoluntaryCessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports